// GENERATED by .scratch/gen-campaign-full.cjs from jcfieldsdev data.js, then hand-maintained.
// SC2 campaign rosters (Wings of Liberty / Heart of the Swarm / Legacy of the Void / Nova Covert
// Ops) + their command entries (bootstrap clause; generate-then-review). Every
// command `key` is bare-key-verified against TheCore (golden guard). A unit's per-mission ability
// lists are UNIONED into one card (you see every hotkey it ever has); per-mission card variants,
// Grid-positional keys, and story upgrade/loadout mutual-exclusions are out of scope. See .scratch
// reports for refs dropped as unresolvable in TheCore (the allowlist tail).
import type { SC2Command, SC2Roster } from "./sc2-registry";

export const CAMPAIGN_COMMANDS: Record<string, SC2Command> = {
  cam_PlantC4Charge_Raynor: {
    name: "Plant Breaching Charge",
    category: "ability",
    key: "PlantC4Charge",
    unit: "Raynor",
  },
  cam_TossGrenade_Raynor: {
    name: "Grenade",
    category: "ability",
    key: "TossGrenade",
    unit: "Raynor",
  },
  cam_ExperimentalPlasmaGun_Raynor: {
    name: "Experimental Plasma Gun",
    category: "ability",
    key: "ExperimentalPlasmaGun",
    unit: "Raynor",
  },
  cam_TheMorosDevice_Raynor: {
    name: "Chrono Rift Device",
    category: "ability",
    key: "TheMorosDevice",
    unit: "Raynor",
  },
  cam_TossGrenadeTychus_TychusCommando: {
    name: "Toss Shredder Grenade",
    category: "ability",
    key: "TossGrenadeTychus",
    unit: "TychusCommando",
  },
  cam_DutchPlaceTurret_Swann: {
    name: "Place Flaming Betty",
    category: "ability",
    key: "DutchPlaceTurret",
    unit: "Swann",
  },
  cam_BonesHeal_Stetmann: { name: "Heal", category: "ability", key: "BonesHeal", unit: "Stetmann" },
  cam_NovaSnipe_Nova: { name: "Snipe", category: "ability", key: "NovaSnipe", unit: "Nova" },
  cam_Domination_Nova: { name: "Domination", category: "ability", key: "Domination", unit: "Nova" },
  cam_ReleaseMinion_Nova: {
    name: "Release Minion",
    category: "ability",
    key: "ReleaseMinion",
    unit: "Nova",
  },
  cam_HeroNukeCalldown_Nova: {
    name: "Tac Nuke Strike",
    category: "ability",
    key: "HeroNukeCalldown",
    unit: "Nova",
  },
  cam_MindBlast_Tosh: { name: "Mindblast", category: "ability", key: "MindBlast", unit: "Tosh" },
  cam_VoodooShield_Tosh: {
    name: "Psi Shield",
    category: "ability",
    key: "VoodooShield",
    unit: "Tosh",
  },
  cam_Consumption_Tosh: {
    name: "Consumption",
    category: "ability",
    key: "Consumption",
    unit: "Tosh",
  },
  cam_HeroNukeCalldown_Tosh: {
    name: "Tac Nuke Strike",
    category: "ability",
    key: "HeroNukeCalldown",
    unit: "Tosh",
  },
  cam_ZeratulBlink_Zeratul: {
    name: "Blink",
    category: "ability",
    key: "ZeratulBlink",
    unit: "Zeratul",
  },
  cam_ZeratulStun_Zeratul: {
    name: "Void Prison",
    category: "ability",
    key: "ZeratulStun",
    unit: "Zeratul",
  },
  cam_GravitonBeam_Urun: {
    name: "Graviton Beam",
    category: "ability",
    key: "GravitonBeam",
    unit: "Urun",
  },
  cam_Interceptor_Selendis: {
    name: "Interceptor",
    category: "ability",
    key: "Interceptor",
    unit: "Selendis",
  },
  cam_MassRecall_Artanis: {
    name: "Mass Recall",
    category: "ability",
    key: "MassRecall",
    unit: "Artanis",
  },
  cam_Vortex_Artanis: { name: "Vortex", category: "ability", key: "Vortex", unit: "Artanis" },
  cam_TerranBuild_SCV_scvbuild0: {
    name: "Build Basic",
    category: "command",
    key: "TerranBuild",
    unit: "SCV",
    opens: "scv_build0",
  },
  cam_TerranBuildAdvanced_SCV_scvbuild1: {
    name: "Build Advanced",
    category: "command",
    key: "TerranBuildAdvanced",
    unit: "SCV",
    opens: "scv_build1",
  },
  cam_SupplyDepot_SCV: {
    name: "Supply Depot",
    category: "structure",
    key: "SupplyDepot",
    unit: "SCV",
  },
  cam_PerditionTurret_SCV: {
    name: "Perdition Turret",
    category: "structure",
    key: "PerditionTurret",
    unit: "SCV",
  },
  cam_HiveMindEmulator_SCV: {
    name: "Hive Mind Emulator",
    category: "structure",
    key: "HiveMindEmulator",
    unit: "SCV",
  },
  cam_MercCompound_SCV: {
    name: "Merc Compound",
    category: "structure",
    key: "MercCompound",
    unit: "SCV",
  },
  cam_D8Charge_Reaper: {
    name: "G-4 Cluster Bombs",
    category: "ability",
    key: "D8Charge",
    unit: "Reaper",
  },
  cam_SpectreHoldFire_Spectre: {
    name: "Hold Fire",
    category: "ability",
    key: "SpectreHoldFire",
    unit: "Spectre",
  },
  cam_SpectreWeaponsFree_Spectre: {
    name: "Weapons Free",
    category: "ability",
    key: "SpectreWeaponsFree",
    unit: "Spectre",
  },
  cam_UltrasonicPulse_Spectre: {
    name: "Ultrasonic Pulse",
    category: "ability",
    key: "UltrasonicPulse",
    unit: "Spectre",
  },
  cam_Obliterate_Spectre: {
    name: "Psionic Lash",
    category: "ability",
    key: "Obliterate",
    unit: "Spectre",
  },
  cam_SpectreNukeCalldown_Spectre: {
    name: "Tac Nuke Strike",
    category: "ability",
    key: "SpectreNukeCalldown",
    unit: "Spectre",
  },
  cam_250mmStrikeCannons_Thor: {
    name: "250mm Strike Cannons",
    category: "ability",
    key: "250mmStrikeCannons",
    unit: "Thor",
  },
  cam_SpiderMine_Vulture: {
    name: "Deploy Spider Mine",
    category: "ability",
    key: "SpiderMine",
    unit: "Vulture",
  },
  cam_SpiderMineReplenish_Vulture: {
    name: "Replenish Spider Mine",
    category: "ability",
    key: "SpiderMineReplenish",
    unit: "Vulture",
  },
  cam_WraithCloakOn_Wraith: {
    name: "Cloak",
    category: "ability",
    key: "WraithCloakOn",
    unit: "Wraith",
  },
  cam_WraithCloakOff_Wraith: {
    name: "Decloak",
    category: "ability",
    key: "WraithCloakOff",
    unit: "Wraith",
  },
  cam_BuildAutoTurret_Raven: {
    name: "Auto-Turret",
    category: "ability",
    key: "BuildAutoTurret",
    unit: "Raven",
  },
  cam_BuildPointDefenseDrone_Raven: {
    name: "Point Defense Drone",
    category: "ability",
    key: "BuildPointDefenseDrone",
    unit: "Raven",
  },
  cam_HunterSeekerMissile_Raven: {
    name: "Seeker Missile",
    category: "ability",
    key: "HunterSeekerMissile",
    unit: "Raven",
  },
  cam_NanoRepair_ScienceVessel: {
    name: "Nano-Repair",
    category: "ability",
    key: "NanoRepair",
    unit: "ScienceVessel",
  },
  cam_Irradiate_ScienceVessel: {
    name: "Irradiate",
    category: "ability",
    key: "Irradiate",
    unit: "ScienceVessel",
  },
  cam_HerculesLoad_Hercules: {
    name: "Load",
    category: "ability",
    key: "HerculesLoad",
    unit: "Hercules",
  },
  cam_HerculesUnloadAll_Hercules: {
    name: "Unload All",
    category: "ability",
    key: "HerculesUnloadAll",
    unit: "Hercules",
  },
  cam_MissilePods_Battlecruiser: {
    name: "Missile Pods",
    category: "ability",
    key: "MissilePods",
    unit: "Battlecruiser",
  },
  cam_DefensiveMatrix_Battlecruiser: {
    name: "Defensive Matrix",
    category: "ability",
    key: "DefensiveMatrix",
    unit: "Battlecruiser",
  },
  cam_OdinBarrage_Odin: { name: "Barrage", category: "ability", key: "OdinBarrage", unit: "Odin" },
  cam_OdinNukeCalldown_Odin: {
    name: "Nuclear Strike",
    category: "ability",
    key: "OdinNukeCalldown",
    unit: "Odin",
  },
  cam_CalldownMULE_CommandCenter: {
    name: "Calldown: MULE",
    category: "unit",
    key: "CalldownMULE",
    unit: "CommandCenter",
  },
  cam_Scan_CommandCenter: {
    name: "Scanner Sweep",
    category: "unit",
    key: "Scan",
    unit: "CommandCenter",
  },
  cam_Lower_SupplyDepot: { name: "Lower", category: "unit", key: "Lower", unit: "SupplyDepot" },
  cam_Raise_SupplyDepotLowered: {
    name: "Raise",
    category: "unit",
    key: "Raise",
    unit: "SupplyDepotLowered",
  },
  cam_Medic_Barracks: { name: "Medic", category: "unit", key: "Medic", unit: "Barracks" },
  cam_Firebat_Barracks: { name: "Firebat", category: "unit", key: "Firebat", unit: "Barracks" },
  cam_TechReactorAI_Barracks: {
    name: "Tech Reactor",
    category: "unit",
    key: "TechReactorAI",
    unit: "Barracks",
  },
  cam_Spectre_Barracks: { name: "Spectre", category: "unit", key: "Spectre", unit: "Barracks" },
  cam_MindControl_HiveMindEmulator: {
    name: "Mind Control",
    category: "unit",
    key: "MindControl",
    unit: "HiveMindEmulator",
  },
  cam_SpectreNukeArm_GhostAcademy: {
    name: "Arm Silo with Nuke",
    category: "unit",
    key: "SpectreNukeArm",
    unit: "GhostAcademy",
  },
  cam_Predator_Factory: { name: "Predator", category: "unit", key: "Predator", unit: "Factory" },
  cam_Vulture_Factory: { name: "Vulture", category: "unit", key: "Vulture", unit: "Factory" },
  cam_Diamondback_Factory: {
    name: "Diamondback",
    category: "unit",
    key: "Diamondback",
    unit: "Factory",
  },
  cam_Goliath_Factory: { name: "Goliath", category: "unit", key: "Goliath", unit: "Factory" },
  cam_TechReactorAI_Factory: {
    name: "Tech Reactor",
    category: "unit",
    key: "TechReactorAI",
    unit: "Factory",
  },
  cam_TerranVehiclePlatingLevel1_Armory: {
    name: "Vehicle Plating",
    category: "ability",
    key: "TerranVehiclePlatingLevel1",
    unit: "Armory",
  },
  cam_TerranShipPlatingLevel1_Armory: {
    name: "Ship Plating",
    category: "ability",
    key: "TerranShipPlatingLevel1",
    unit: "Armory",
  },
  cam_Wraith_Starport: { name: "Wraith", category: "unit", key: "Wraith", unit: "Starport" },
  cam_BuildHercules_Starport: {
    name: "Hercules",
    category: "unit",
    key: "BuildHercules",
    unit: "Starport",
  },
  cam_TechReactorAI_Starport: {
    name: "Tech Reactor",
    category: "unit",
    key: "TechReactorAI",
    unit: "Starport",
  },
  cam_HireKelmorianMiners_MercCompound: {
    name: "War Pigs",
    category: "unit",
    key: "HireKelmorianMiners",
    unit: "MercCompound",
  },
  cam_HireDevilDogs_MercCompound: {
    name: "Devil Dogs",
    category: "unit",
    key: "HireDevilDogs",
    unit: "MercCompound",
  },
  cam_HireHammerSecurities_MercCompound: {
    name: "Hammer Securities",
    category: "unit",
    key: "HireHammerSecurities",
    unit: "MercCompound",
  },
  cam_HireSpartanCompany_MercCompound: {
    name: "Spartan Company",
    category: "unit",
    key: "HireSpartanCompany",
    unit: "MercCompound",
  },
  cam_HireSiegeBreakers_MercCompound: {
    name: "Siege Breakers",
    category: "unit",
    key: "HireSiegeBreakers",
    unit: "MercCompound",
  },
  cam_HireHelsAngels_MercCompound: {
    name: "Hel’s Angels",
    category: "unit",
    key: "HireHelsAngels",
    unit: "MercCompound",
  },
  cam_HireDuskWing_MercCompound: {
    name: "Dusk Wings",
    category: "unit",
    key: "HireDuskWing",
    unit: "MercCompound",
  },
  cam_HireDukesRevenge_MercCompound: {
    name: "Jackson’s Revenge",
    category: "unit",
    key: "HireDukesRevenge",
    unit: "MercCompound",
  },
  cam_MindBolt_K5Kerrigan: {
    name: "Leaping Strike",
    category: "ability",
    key: "MindBolt",
    unit: "K5Kerrigan",
  },
  cam_PsionicLift_K5Kerrigan: {
    name: "Psionic Shift",
    category: "ability",
    key: "PsionicLift",
    unit: "K5Kerrigan",
  },
  cam_WildMutation_K5Kerrigan: {
    name: "Wild Mutation",
    category: "ability",
    key: "WildMutation",
    unit: "K5Kerrigan",
  },
  cam_K5Leviathan_K5Kerrigan: {
    name: "Spawn Leviathan",
    category: "ability",
    key: "K5Leviathan",
    unit: "K5Kerrigan",
  },
  cam_ParasiticInvasion_LarvalQueen: {
    name: "Parasitic Invasion",
    category: "ability",
    key: "ParasiticInvasion",
    unit: "LarvalQueen",
  },
  cam_GrowSwarmQueen_LarvalQueen: {
    name: "Grow",
    category: "ability",
    key: "GrowSwarmQueen",
    unit: "LarvalQueen",
  },
  cam_SwarmQueenZergling_SwarmQueen: {
    name: "Birth Zergling",
    category: "ability",
    key: "SwarmQueenZergling",
    unit: "SwarmQueen",
  },
  cam_SwarmQueenRoach_LargeSwarmQueen: {
    name: "Birth Roach",
    category: "ability",
    key: "SwarmQueenRoach",
    unit: "LargeSwarmQueen",
  },
  cam_DevastatingShot_InfestedStukov: {
    name: "Corrosive Blast",
    category: "ability",
    key: "DevastatingShot",
    unit: "InfestedStukov",
  },
  cam_StukovInfestedTerrans_InfestedStukov: {
    name: "Spawn Infested Terrans",
    category: "ability",
    key: "StukovInfestedTerrans",
    unit: "InfestedStukov",
  },
  cam_Drag_Dehaka: { name: "Drag", category: "ability", key: "Drag", unit: "Dehaka" },
  cam_DehakaMirrorImage_Dehaka: {
    name: "Generate Spawns",
    category: "ability",
    key: "DehakaMirrorImage",
    unit: "Dehaka",
  },
  cam_DehakaHeal_Dehaka: { name: "Mend", category: "ability", key: "DehakaHeal", unit: "Dehaka" },
  cam_SJHyperionFightersRecall_SJHyperion: {
    name: "Recall Fighters",
    category: "ability",
    key: "SJHyperionFightersRecall",
    unit: "SJHyperion",
  },
  cam_SJHyperionBlink_SJHyperion: {
    name: "Jump",
    category: "ability",
    key: "SJHyperionBlink",
    unit: "SJHyperion",
  },
  cam_SJHyperionFighters_SJHyperion: {
    name: "Fighter Strike",
    category: "ability",
    key: "SJHyperionFighters",
    unit: "SJHyperion",
  },
  cam_SJHyperionYamato_SJHyperion: {
    name: "Yamato Cannon",
    category: "ability",
    key: "SJHyperionYamato",
    unit: "SJHyperion",
  },
  cam_SJHyperionLightningStorm_SJHyperion: {
    name: "Electric Field",
    category: "ability",
    key: "SJHyperionLightningStorm",
    unit: "SJHyperion",
  },
  cam_HotSBioPlasmidDischarge_HotSLeviathan: {
    name: "Bio-Plasmid Discharge",
    category: "ability",
    key: "HotSBioPlasmidDischarge",
    unit: "HotSLeviathan",
  },
  cam_HotSBioStasis_HotSLeviathan: {
    name: "Bio-Stasis",
    category: "ability",
    key: "HotSBioStasis",
    unit: "HotSLeviathan",
  },
  cam_TornadoMissile_WarHound: {
    name: "Haywire Missiles",
    category: "ability",
    key: "TornadoMissile",
    unit: "WarHound",
  },
  cam_Consume_Lyote: { name: "Consume Host", category: "ability", key: "Consume", unit: "Lyote" },
  cam_GiantYetiLeap_GiantYeti: {
    name: "Leap",
    category: "ability",
    key: "GiantYetiLeap",
    unit: "GiantYeti",
  },
  cam_Consume_GiantYeti: {
    name: "Consume Host",
    category: "ability",
    key: "Consume",
    unit: "GiantYeti",
  },
  cam_Aberration_Larva: {
    name: "Aberration",
    category: "ability",
    key: "Aberration",
    unit: "Larva",
  },
  cam_ZergBuild_Drone_dronebuild0: {
    name: "Build Basic",
    category: "command",
    key: "ZergBuild",
    unit: "Drone",
    opens: "drone_build0",
  },
  cam_ZergBuildAdvanced_Drone_dronebuild1: {
    name: "Build Advanced",
    category: "command",
    key: "ZergBuildAdvanced",
    unit: "Drone",
    opens: "drone_build1",
  },
  cam_SpawningPool_Drone: {
    name: "Spawning Pool",
    category: "structure",
    key: "SpawningPool",
    unit: "Drone",
  },
  cam_QueenBurstHeal_Queen: {
    name: "Rapid Transfusion",
    category: "ability",
    key: "QueenBurstHeal",
    unit: "Queen",
  },
  cam_Explode_HotSSplitterlingBig: {
    name: "Explode",
    category: "ability",
    key: "Explode",
    unit: "HotSSplitterlingBig",
  },
  cam_EnableBuildingAttack_HotSSplitterlingBig: {
    name: "Enable Structure Attack",
    category: "ability",
    key: "EnableBuildingAttack",
    unit: "HotSSplitterlingBig",
  },
  cam_DisableBuildingAttack_HotSSplitterlingBig: {
    name: "Disable Structure Attack",
    category: "ability",
    key: "DisableBuildingAttack",
    unit: "HotSSplitterlingBig",
  },
  cam_DisableBuildingAttack_HotSSplitterlingMedium: {
    name: "Disable Structure Attack",
    category: "ability",
    key: "DisableBuildingAttack",
    unit: "HotSSplitterlingMedium",
  },
  cam_Impaler_HydraliskImpaler: {
    name: "Impaler",
    category: "ability",
    key: "Impaler",
    unit: "HydraliskImpaler",
  },
  cam_HydraliskFrenzy_HydraliskImpaler: {
    name: "Frenzy",
    category: "ability",
    key: "HydraliskFrenzy",
    unit: "HydraliskImpaler",
  },
  cam_Lurker_HydraliskLurker: {
    name: "Lurker",
    category: "ability",
    key: "Lurker",
    unit: "HydraliskLurker",
  },
  cam_HydraliskFrenzy_HydraliskLurker: {
    name: "Frenzy",
    category: "ability",
    key: "HydraliskFrenzy",
    unit: "HydraliskLurker",
  },
  cam_ImpalerBurrowDown: { name: "Burrow", category: "ability", key: "ImpalerBurrowDown" },
  cam_ImpalerBurrowUp: { name: "Unburrow", category: "ability", key: "ImpalerBurrowUp" },
  cam_LurkerBurrowUp: { name: "Unburrow", category: "ability", key: "LurkerBurrowUp" },
  cam_NPSwarm_Infestor: {
    name: "Parasitic Domination",
    category: "ability",
    key: "NPSwarm",
    unit: "Infestor",
  },
  cam_InfestorConsumption_Infestor: {
    name: "Consumption",
    category: "ability",
    key: "InfestorConsumption",
    unit: "Infestor",
  },
  cam_SwarmHostRoot: { name: "Root", category: "ability", key: "SwarmHostRoot" },
  cam_LocustLaunch_SwarmHostRooted: {
    name: "Spawn Locusts",
    category: "ability",
    key: "LocustLaunch",
    unit: "SwarmHostRooted",
  },
  cam_SwarmHostUproot: { name: "Uproot", category: "ability", key: "SwarmHostUproot" },
  cam_SwarmHostRoot_2: { name: "Root", category: "ability", key: "SwarmHostRoot" },
  cam_LocustFlyingLaunch_SwarmHostSplitARooted: {
    name: "Spawn Locusts",
    category: "ability",
    key: "LocustFlyingLaunch",
    unit: "SwarmHostSplitARooted",
  },
  cam_SwarmHostUproot_2: { name: "Uproot", category: "ability", key: "SwarmHostUproot" },
  cam_SwarmHostDeepBurrow_SwarmHostSplitB: {
    name: "Deep Tunnel",
    category: "ability",
    key: "SwarmHostDeepBurrow",
    unit: "SwarmHostSplitB",
  },
  cam_SwarmHostRoot_3: { name: "Root", category: "ability", key: "SwarmHostRoot" },
  cam_LocustLaunchCreeper_SwarmHostSplitBRooted: {
    name: "Spawn Locusts",
    category: "ability",
    key: "LocustLaunchCreeper",
    unit: "SwarmHostSplitBRooted",
  },
  cam_SwarmHostUproot_3: { name: "Uproot", category: "ability", key: "SwarmHostUproot" },
  cam_BroodLord_MutaliskBroodlord: {
    name: "Brood Lord",
    category: "ability",
    key: "BroodLord",
    unit: "MutaliskBroodlord",
  },
  cam_Viper_MutaliskViper: {
    name: "Viper",
    category: "ability",
    key: "Viper",
    unit: "MutaliskViper",
  },
  cam_DisablingCloud_Viper: {
    name: "Disabling Cloud",
    category: "ability",
    key: "DisablingCloud",
    unit: "Viper",
  },
  cam_ViperConsumption_Viper: {
    name: "Consumption",
    category: "ability",
    key: "ViperConsumption",
    unit: "Viper",
  },
  cam_BurrowChargeCampaign_Ultralisk: {
    name: "Burrow Charge",
    category: "ability",
    key: "BurrowChargeCampaign",
    unit: "Ultralisk",
  },
  cam_PoisonNova_HotSNoxious: {
    name: "Toxic Blast",
    category: "ability",
    key: "PoisonNova",
    unit: "HotSNoxious",
  },
  cam_BurrowChargeCampaignNoxious_HotSNoxious: {
    name: "Burrow Charge",
    category: "ability",
    key: "BurrowChargeCampaignNoxious",
    unit: "HotSNoxious",
  },
  cam_RespawnZergling_Hatchery: {
    name: "Zergling Reconstitution",
    category: "unit",
    key: "RespawnZergling",
    unit: "Hatchery",
  },
  cam_LurkerDen_HydraliskDen: {
    name: "Lurker Den",
    category: "unit",
    key: "LurkerDen",
    unit: "HydraliskDen",
  },
  cam_GreaterSpireBroodlord_Spire: {
    name: "Greater Spire",
    category: "unit",
    key: "GreaterSpireBroodlord",
    unit: "Spire",
  },
  cam_Medic_Barracks_2: { name: "Medic", category: "unit", key: "Medic", unit: "Barracks" },
  cam_Firebat_Barracks_2: { name: "Firebat", category: "unit", key: "Firebat", unit: "Barracks" },
  cam_Spectre_Barracks_2: { name: "Spectre", category: "unit", key: "Spectre", unit: "Barracks" },
  cam_TechReactorAI_Barracks_2: {
    name: "Tech Reactor",
    category: "unit",
    key: "TechReactorAI",
    unit: "Barracks",
  },
  cam_HireDevilDogs_Barracks: {
    name: "Devil Dogs",
    category: "unit",
    key: "HireDevilDogs",
    unit: "Barracks",
  },
  cam_MercMedic_Barracks: {
    name: "Skibi’s Angels",
    category: "unit",
    key: "MercMedic",
    unit: "Barracks",
  },
  cam_WarHound_Factory: { name: "Warhound", category: "unit", key: "WarHound", unit: "Factory" },
  cam_CampaignVehicles_Factory: {
    name: "Campaign Vehicles",
    category: "unit",
    key: "CampaignVehicles",
    unit: "Factory",
  },
  cam_TechReactorAI_Factory_2: {
    name: "Tech Reactor",
    category: "unit",
    key: "TechReactorAI",
    unit: "Factory",
  },
  cam_Vulture_Factory_2: { name: "Vulture", category: "unit", key: "Vulture", unit: "Factory" },
  cam_Predator_Factory_2: { name: "Predator", category: "unit", key: "Predator", unit: "Factory" },
  cam_Diamondback_Factory_2: {
    name: "Diamondback",
    category: "unit",
    key: "Diamondback",
    unit: "Factory",
  },
  cam_CampaignVehicles_Starport: {
    name: "Campaign Vehicles",
    category: "unit",
    key: "CampaignVehicles",
    unit: "Starport",
  },
  cam_TechReactorAI_Starport_2: {
    name: "Tech Reactor",
    category: "unit",
    key: "TechReactorAI",
    unit: "Starport",
  },
  cam_BuildHercules_Starport_2: {
    name: "Hercules",
    category: "unit",
    key: "BuildHercules",
    unit: "Starport",
  },
  cam_HireDuskWing_Starport: {
    name: "Dusk Wings",
    category: "unit",
    key: "HireDuskWing",
    unit: "Starport",
  },
  cam_ZeratulBlink_PrologueZeratul: {
    name: "Blink",
    category: "ability",
    key: "ZeratulBlink",
    unit: "PrologueZeratul",
  },
  cam_PrologueVoidArmor_PrologueZeratul: {
    name: "Void Armor",
    category: "ability",
    key: "PrologueVoidArmor",
    unit: "PrologueZeratul",
  },
  cam_ShadowBlade_PrologueZeratul: {
    name: "Shadow Strike",
    category: "ability",
    key: "ShadowBlade",
    unit: "PrologueZeratul",
  },
  cam_ArtanisLightningDash_ArtanisVoid: {
    name: "Lightning Dash",
    category: "ability",
    key: "ArtanisLightningDash",
    unit: "ArtanisVoid",
  },
  cam_ArtanisAstralWind_ArtanisVoid: {
    name: "Astral Wind",
    category: "ability",
    key: "ArtanisAstralWind",
    unit: "ArtanisVoid",
  },
  cam_VorazunBlink_VorazunChampion: {
    name: "Shadow Dash",
    category: "ability",
    key: "VorazunBlink",
    unit: "VorazunChampion",
  },
  cam_MohandarOmnislash_VorazunChampion: {
    name: "Shadow Fury",
    category: "ability",
    key: "MohandarOmnislash",
    unit: "VorazunChampion",
  },
  cam_AlarakKnockback_AlarakChampion: {
    name: "Destruction Wave",
    category: "ability",
    key: "AlarakKnockback",
    unit: "AlarakChampion",
  },
  cam_AlarakDeadlyCharge_AlarakChampion: {
    name: "Deadly Charge",
    category: "ability",
    key: "AlarakDeadlyCharge",
    unit: "AlarakChampion",
  },
  cam_Reclamation_KaraxChampion: {
    name: "Reclamation",
    category: "ability",
    key: "Reclamation",
    unit: "KaraxChampion",
  },
  cam_PhaseCannon_KaraxChampion: {
    name: "Phase Cannon",
    category: "ability",
    key: "PhaseCannon",
    unit: "KaraxChampion",
  },
  cam_FenixSOACharge_FenixChampion: {
    name: "Thunderous Charge",
    category: "ability",
    key: "FenixSOACharge",
    unit: "FenixChampion",
  },
  cam_FenixWhirlwind_FenixChampion: {
    name: "Whirlwind",
    category: "ability",
    key: "FenixWhirlwind",
    unit: "FenixChampion",
  },
  cam_VoidShieldCapacitor_FenixChampion: {
    name: "Shield Capacitor",
    category: "ability",
    key: "VoidShieldCapacitor",
    unit: "FenixChampion",
  },
  cam_KerriganVoidKineticBlast_KerriganVoidUlnar02: {
    name: "Kinetic Blast",
    category: "ability",
    key: "KerriganVoidKineticBlast",
    unit: "KerriganVoidUlnar02",
  },
  cam_KerriganVoidSpawnBanelings_KerriganVoidUlnar02: {
    name: "Spawn Banelings",
    category: "ability",
    key: "KerriganVoidSpawnBanelings",
    unit: "KerriganVoidUlnar02",
  },
  cam_KerriganEpilogue03Heal_KerriganEpilogue03: {
    name: "Celestial Radiance",
    category: "ability",
    key: "KerriganEpilogue03Heal",
    unit: "KerriganEpilogue03",
  },
  cam_KerriganEpilogue03Extinction_KerriganEpilogue03: {
    name: "Extinction",
    category: "ability",
    key: "KerriganEpilogue03Extinction",
    unit: "KerriganEpilogue03",
  },
  cam_ProtossBuild_Probe_probebuild0: {
    name: "Warp In",
    category: "command",
    key: "ProtossBuild",
    unit: "Probe",
    opens: "probe_build0",
  },
  cam_ProtossBuildAdvanced_Probe_probebuild1: {
    name: "Warp In Adv.",
    category: "command",
    key: "ProtossBuildAdvanced",
    unit: "Probe",
    opens: "probe_build1",
  },
  cam_KhaydarinMonolith_Probe: {
    name: "Khaydarin Monolith",
    category: "structure",
    key: "KhaydarinMonolith",
    unit: "Probe",
  },
  cam_Charge_ZealotAiur: { name: "Charge", category: "ability", key: "Charge", unit: "ZealotAiur" },
  cam_VoidZealotWhirlwind_ZealotAiur: {
    name: "Whirlwind",
    category: "ability",
    key: "VoidZealotWhirlwind",
    unit: "ZealotAiur",
  },
  cam_VoidZealotShadowCharge_ZealotShakuras: {
    name: "Shadow Charge",
    category: "ability",
    key: "VoidZealotShadowCharge",
    unit: "ZealotShakuras",
  },
  cam_VoidZealotShadowChargeStun_ZealotShakuras: {
    name: "Darkcoil",
    category: "ability",
    key: "VoidZealotShadowChargeStun",
    unit: "ZealotShakuras",
  },
  cam_Charge_ZealotPurifier: {
    name: "Charge",
    category: "ability",
    key: "Charge",
    unit: "ZealotPurifier",
  },
  cam_VoidSentryShieldRepairDouble_SentryAiur: {
    name: "Double Shield Recharge",
    category: "ability",
    key: "VoidSentryShieldRepairDouble",
    unit: "SentryAiur",
  },
  cam_GuardianShield_SentryAiur: {
    name: "Guardian Shield",
    category: "ability",
    key: "GuardianShield",
    unit: "SentryAiur",
  },
  cam_VoidSentryChronoBeam_SentryPurifier: {
    name: "Chrono Beam",
    category: "ability",
    key: "VoidSentryChronoBeam",
    unit: "SentryPurifier",
  },
  cam_VoidSentryPhasingMode_SentryPurifier: {
    name: "Phasing Mode",
    category: "ability",
    key: "VoidSentryPhasingMode",
    unit: "SentryPurifier",
  },
  cam_VoidSentryMobileMode_SentryPurifier: {
    name: "Mobile Mode",
    category: "ability",
    key: "VoidSentryMobileMode",
    unit: "SentryPurifier",
  },
  cam_TargetLock_Monitor: {
    name: "Target Lock",
    category: "ability",
    key: "TargetLock",
    unit: "Monitor",
  },
  cam_SentryTaldarimForceField_Monitor: {
    name: "Force Field",
    category: "ability",
    key: "SentryTaldarimForceField",
    unit: "Monitor",
  },
  cam_StalkerBlinkShieldRestoreBase_StalkerShakuras: {
    name: "Blink",
    category: "ability",
    key: "StalkerBlinkShieldRestoreBase",
    unit: "StalkerShakuras",
  },
  cam_DarkArchonConfusion_DarkArchon: {
    name: "Confusion",
    category: "ability",
    key: "DarkArchonConfusion",
    unit: "DarkArchon",
  },
  cam_DarkArchonMindControl_DarkArchon: {
    name: "Mind Control",
    category: "ability",
    key: "DarkArchonMindControl",
    unit: "DarkArchon",
  },
  cam_VoidHighTemplarPsiOrb_HighTemplarTaldarim: {
    name: "Psionic Orb",
    category: "ability",
    key: "VoidHighTemplarPsiOrb",
    unit: "HighTemplarTaldarim",
  },
  cam_VoidHighTemplarMindBlast_HighTemplarTaldarim: {
    name: "Mind Blast",
    category: "ability",
    key: "VoidHighTemplarMindBlast",
    unit: "HighTemplarTaldarim",
  },
  cam_AscendantSacrifice_HighTemplarTaldarim: {
    name: "Sacrifice",
    category: "ability",
    key: "AscendantSacrifice",
    unit: "HighTemplarTaldarim",
  },
  cam_VoidDarkTemplarShadowFury_DarkTemplarShakuras: {
    name: "Shadow Fury",
    category: "ability",
    key: "VoidDarkTemplarShadowFury",
    unit: "DarkTemplarShakuras",
  },
  cam_VoidStasis_DarkTemplarTaldarim: {
    name: "Void Stasis",
    category: "ability",
    key: "VoidStasis",
    unit: "DarkTemplarTaldarim",
  },
  cam_ImmortalOverload_Immortal: {
    name: "Barrier",
    category: "ability",
    key: "ImmortalOverload",
    unit: "Immortal",
  },
  cam_ImmortalShakurasShadowCannon_ImmortalShakuras: {
    name: "Shadow Cannon",
    category: "ability",
    key: "ImmortalShakurasShadowCannon",
    unit: "ImmortalShakuras",
  },
  cam_ReaverScarabs_Reaver: {
    name: "Create Scarab",
    category: "ability",
    key: "ReaverScarabs",
    unit: "Reaver",
  },
  cam_CorsairMPDisruptionWeb_CorsairMP: {
    name: "Disruption Web",
    category: "ability",
    key: "CorsairMPDisruptionWeb",
    unit: "CorsairMP",
  },
  cam_GravitonBeam_PhoenixPurifier: {
    name: "Graviton Beam",
    category: "ability",
    key: "GravitonBeam",
    unit: "PhoenixPurifier",
  },
  cam_ArbiterMPStasisField_ArbiterMP: {
    name: "Stasis Field",
    category: "ability",
    key: "ArbiterMPStasisField",
    unit: "ArbiterMP",
  },
  cam_ArbiterMPRecall_ArbiterMP: {
    name: "Recall",
    category: "ability",
    key: "ArbiterMPRecall",
    unit: "ArbiterMP",
  },
  cam_RepairDrones_Carrier: {
    name: "Repair Drones",
    category: "ability",
    key: "RepairDrones",
    unit: "Carrier",
  },
  cam_LightningBomb_Tempest: {
    name: "Disintegration",
    category: "ability",
    key: "LightningBomb",
    unit: "Tempest",
  },
  cam_VoidSentryBlackHole_SOAMothershipv4: {
    name: "Black Hole",
    category: "ability",
    key: "VoidSentryBlackHole",
    unit: "SOAMothershipv4",
  },
  cam_SOAMothershipLineAttack_SOAMothershipv4: {
    name: "Thermal Lance",
    category: "ability",
    key: "SOAMothershipLineAttack",
    unit: "SOAMothershipv4",
  },
  cam_SOAMothershipBlink_SOAMothershipv4: {
    name: "Blink",
    category: "ability",
    key: "SOAMothershipBlink",
    unit: "SOAMothershipv4",
  },
  cam_QueenClassicParasite_QueenClassic: {
    name: "Parasite",
    category: "ability",
    key: "QueenClassicParasite",
    unit: "QueenClassic",
  },
  cam_QueenMPEnsnare_QueenClassic: {
    name: "Ensnare",
    category: "ability",
    key: "QueenMPEnsnare",
    unit: "QueenClassic",
  },
  cam_QueenMPSpawnBroodlings_QueenClassic: {
    name: "Spawn Broodlings",
    category: "ability",
    key: "QueenMPSpawnBroodlings",
    unit: "QueenClassic",
  },
  cam_CreepTumor_QueenClassic: {
    name: "Creep Tumor",
    category: "ability",
    key: "CreepTumor",
    unit: "QueenClassic",
  },
  cam_TimeWarp_Nexus: { name: "Chrono Boost", category: "unit", key: "TimeWarp", unit: "Nexus" },
  cam_UpgradeToRoboticsFacilityWarp_RoboticsFacility: {
    name: "Transform to Warp Robotics Facility",
    category: "ability",
    key: "UpgradeToRoboticsFacilityWarp",
    unit: "RoboticsFacility",
  },
  cam_MorphBackToRoboticsFacility_RoboticsFacilityWarp: {
    name: "Transform to Robotics Facility",
    category: "unit",
    key: "MorphBackToRoboticsFacility",
    unit: "RoboticsFacilityWarp",
  },
  cam_UpgradeToStargateWarp_Stargate: {
    name: "Transform to Warp Stargate",
    category: "ability",
    key: "UpgradeToStargateWarp",
    unit: "Stargate",
  },
  cam_MorphBackToStargate_StargateWarp: {
    name: "Transform to Stargate",
    category: "unit",
    key: "MorphBackToStargate",
    unit: "StargateWarp",
  },
  cam_GhostHoldFire_NovaHero: {
    name: "Hold Fire",
    category: "ability",
    key: "GhostHoldFire",
    unit: "NovaHero",
  },
  cam_WeaponsFree_NovaHero: {
    name: "Weapons Free",
    category: "ability",
    key: "WeaponsFree",
    unit: "NovaHero",
  },
  cam_NovaWeaponCanisterRifleSnipe_NovaHero: {
    name: "Snipe",
    category: "ability",
    key: "NovaWeaponCanisterRifleSnipe",
    unit: "NovaHero",
  },
  cam_NovaGadgetPulseGrenades_NovaHero: {
    name: "Pulse Grenades",
    short: "Pulse Grenade",
    category: "ability",
    key: "NovaGadgetPulseGrenades",
    unit: "NovaHero",
  },
  cam_ApolloCloakOnNova_NovaHero: {
    name: "Cloak",
    category: "ability",
    key: "ApolloCloakOnNova",
    unit: "NovaHero",
  },
  cam_NovaDomination_NovaHero: {
    name: "Domination",
    category: "ability",
    key: "NovaDomination",
    unit: "NovaHero",
  },
  cam_HeroNukeCalldown_NovaHero: {
    name: "Tac Nuke Strike",
    category: "ability",
    key: "HeroNukeCalldown",
    unit: "NovaHero",
  },
  cam_TerranBuild_SCV_scvbuild0_2: {
    name: "Build Basic",
    category: "command",
    key: "TerranBuild",
    unit: "SCV",
    opens: "scv_build0",
  },
  cam_TerranBuildAdvanced_SCV_scvbuild1_2: {
    name: "Build Advanced",
    category: "command",
    key: "TerranBuildAdvanced",
    unit: "SCV",
    opens: "scv_build1",
  },
  cam_SupplyDepot_SCV_2: {
    name: "Supply Depot",
    category: "structure",
    key: "SupplyDepot",
    unit: "SCV",
  },
  cam_MagrailMunitions_Marine: {
    name: "Magrail Munitions",
    category: "ability",
    key: "MagrailMunitions",
    unit: "Marine",
  },
  cam_MagrailMunitions_Marauder: {
    name: "Magrail Munitions",
    category: "ability",
    key: "MagrailMunitions",
    unit: "Marauder",
  },
  cam_DeploySpiderMines_SiegeTank: {
    name: "Deploy Spider Mines",
    category: "ability",
    key: "DeploySpiderMines",
    unit: "SiegeTank",
  },
  cam_HunterSeekerMissile_Raven_2: {
    name: "Seeker Missile",
    category: "ability",
    key: "HunterSeekerMissile",
    unit: "Raven",
  },
  cam_HercGrapple_HERC: { name: "Grapple", category: "ability", key: "HercGrapple", unit: "HERC" },
  cam_EMP_NovaSonarDrone: {
    name: "EMP Round",
    category: "ability",
    key: "EMP",
    unit: "NovaSonarDrone",
  },
  cam_InfestorConsumption_DefilerMP: {
    name: "Consumption",
    category: "ability",
    key: "InfestorConsumption",
    unit: "DefilerMP",
  },
  cam_Lower_SupplyDepot_2: { name: "Lower", category: "unit", key: "Lower", unit: "SupplyDepot" },
  cam_Raise_SupplyDepotLowered_2: {
    name: "Raise",
    category: "unit",
    key: "Raise",
    unit: "SupplyDepotLowered",
  },
  cam_Salvage_MissileTurret: {
    name: "Salvage",
    category: "unit",
    key: "Salvage",
    unit: "MissileTurret",
  },
  cam_Goliath_Factory_2: { name: "Goliath", category: "unit", key: "Goliath", unit: "Factory" },
  cam_TerranVehicleAndShipWeaponsLevel1_Armory: {
    name: "Vehicle and Ship Weapons",
    category: "ability",
    key: "TerranVehicleAndShipWeaponsLevel1",
    unit: "Armory",
  },
};

export const CAMPAIGN_ROSTERS: Record<string, SC2Roster> = {
  wol: {
    label: "Wings of Liberty",
    race: "terran",
    modes: ["campaign"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "raynor",
        cluster: "basic",
        label: "Jim Raynor",
        kind: "unit",
        card: [
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "cam_PlantC4Charge_Raynor",
          "cam_TossGrenade_Raynor",
          "cam_ExperimentalPlasmaGun_Raynor",
          "cam_TheMorosDevice_Raynor",
        ],
      },
      {
        id: "tychus",
        label: "Tychus Findlay",
        kind: "unit",
        card: ["cam_TossGrenadeTychus_TychusCommando"],
      },
      {
        id: "swann",
        cluster: "basic",
        label: "Rory Swann",
        kind: "unit",
        card: ["cam_DutchPlaceTurret_Swann", "stop", "attack"],
      },
      {
        id: "stetmann",
        cluster: "flying",
        label: "Egon Stetmann",
        kind: "unit",
        card: ["cam_BonesHeal_Stetmann"],
      },
      {
        id: "nova",
        cluster: "basic",
        cancel: true,
        label: "Nova",
        kind: "unit",
        card: [
          "cam_NovaSnipe_Nova",
          "cam_Domination_Nova",
          "cam_ReleaseMinion_Nova",
          "cam_HeroNukeCalldown_Nova",
        ],
      },
      {
        id: "tosh",
        cluster: "basic",
        label: "Tosh",
        kind: "unit",
        card: [
          "cam_MindBlast_Tosh",
          "cam_VoodooShield_Tosh",
          "cam_Consumption_Tosh",
          "cam_HeroNukeCalldown_Tosh",
        ],
      },
      {
        id: "zeratul",
        cluster: "basic",
        label: "Zeratul",
        kind: "unit",
        card: ["cam_ZeratulBlink_Zeratul", "cam_ZeratulStun_Zeratul"],
      },
      {
        id: "urun",
        cluster: "basic",
        cancel: true,
        label: "Urun",
        kind: "unit",
        card: ["cam_GravitonBeam_Urun"],
      },
      {
        id: "selendis",
        cluster: "basic",
        cancel: true,
        label: "Selendis",
        kind: "unit",
        card: ["cam_Interceptor_Selendis"],
      },
      {
        id: "artanis",
        cluster: "basic",
        label: "Artanis",
        kind: "unit",
        card: ["cam_MassRecall_Artanis", "cam_Vortex_Artanis"],
      },
      {
        id: "scv",
        cluster: "basic",
        cancel: true,
        label: "SCV",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "cam_TerranBuild_SCV_scvbuild0",
          "cam_TerranBuildAdvanced_SCV_scvbuild1",
          "repair",
          "tHalt",
        ],
      },
      {
        id: "scv_build0",
        cancel: true,
        label: "Build Structure",
        kind: "building",
        parent: "scv",
        card: [
          "bCmdCtr",
          "bRef",
          "cam_SupplyDepot_SCV",
          "bRax",
          "bEbay",
          "cam_PerditionTurret_SCV",
          "bBunker",
          "bMissile",
          "bSensor",
          "cam_HiveMindEmulator_SCV",
        ],
      },
      {
        id: "scv_build1",
        cancel: true,
        label: "Build Advanced Structure",
        kind: "building",
        parent: "scv",
        card: ["bGhostAcad", "cam_MercCompound_SCV", "bFactory", "bArmory", "bStarport", "bFusion"],
      },
      {
        id: "mule",
        cluster: "flying",
        label: "MULE",
        kind: "unit",
        card: ["gatherProt", "returnCargo", "repair"],
      },
      { id: "marine", cluster: "basic", label: "Marine", kind: "unit", card: ["tStim"] },
      {
        id: "reaper",
        cluster: "basic",
        label: "Reaper",
        kind: "unit",
        card: ["cam_D8Charge_Reaper"],
      },
      { id: "medic", cluster: "flying", label: "Medic", kind: "unit", card: ["heal"] },
      {
        id: "ghost",
        cluster: "basic",
        cancel: true,
        label: "Ghost",
        kind: "unit",
        card: [
          "nuke",
          "holdfire",
          "tWeaponsFreeGhost",
          "snipe",
          "emp",
          "tCloakOnBanshee",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "tCloakOff",
        ],
      },
      {
        id: "spectre",
        cluster: "basic",
        cancel: true,
        label: "Spectre",
        kind: "unit",
        card: [
          "cam_SpectreHoldFire_Spectre",
          "cam_SpectreWeaponsFree_Spectre",
          "cam_UltrasonicPulse_Spectre",
          "cam_Obliterate_Spectre",
          "tCloakOnBanshee",
          "cam_SpectreNukeCalldown_Spectre",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "tCloakOff",
        ],
      },
      {
        id: "siegetank",
        cluster: "basic",
        label: "Siege Tank",
        kind: "unit",
        card: ["tSiegeMode", "tUnsiege"],
      },
      {
        id: "thor",
        cluster: "basic",
        cancel: true,
        label: "Thor",
        kind: "unit",
        card: ["cam_250mmStrikeCannons_Thor"],
      },
      {
        id: "vulture",
        cluster: "basic",
        cancel: true,
        label: "Vulture",
        kind: "unit",
        card: ["cam_SpiderMine_Vulture", "cam_SpiderMineReplenish_Vulture"],
      },
      {
        id: "viking",
        cluster: "basic",
        label: "Viking",
        kind: "unit",
        card: ["tAssaultMode", "tFighterMode"],
      },
      {
        id: "wraith",
        cluster: "basic",
        label: "Wraith",
        kind: "unit",
        card: ["cam_WraithCloakOn_Wraith", "cam_WraithCloakOff_Wraith"],
      },
      {
        id: "medivac",
        cluster: "flying",
        label: "Medivac",
        kind: "unit",
        card: ["tHealMedivac", "tBunkerLoad", "tBunkerUnloadAll"],
      },
      {
        id: "banshee",
        cluster: "basic",
        label: "Banshee",
        kind: "unit",
        card: ["tCloakOnBanshee", "tCloakOff"],
      },
      {
        id: "raven",
        cluster: "flying",
        label: "Raven",
        kind: "unit",
        card: [
          "cam_BuildAutoTurret_Raven",
          "cam_BuildPointDefenseDrone_Raven",
          "cam_HunterSeekerMissile_Raven",
          "stop",
          "attack",
        ],
      },
      {
        id: "sciencevessel",
        cluster: "flying",
        label: "Science Vessel",
        kind: "unit",
        card: ["cam_NanoRepair_ScienceVessel", "cam_Irradiate_ScienceVessel"],
      },
      {
        id: "hercules",
        cluster: "flying",
        label: "Hercules",
        kind: "unit",
        card: ["cam_HerculesLoad_Hercules", "cam_HerculesUnloadAll_Hercules"],
      },
      {
        id: "battlecruiser",
        cluster: "basic",
        label: "Battlecruiser",
        kind: "unit",
        card: ["tYamatoGun", "cam_MissilePods_Battlecruiser", "cam_DefensiveMatrix_Battlecruiser"],
      },
      {
        id: "odin",
        cluster: "basic",
        cancel: true,
        label: "Odin",
        kind: "unit",
        card: ["cam_OdinBarrage_Odin", "cam_OdinNukeCalldown_Odin"],
      },
      {
        id: "commandcenter",
        cancel: true,
        label: "Command Center",
        kind: "building",
        card: [
          "tScv",
          "tUpgradeToPlanetaryFortressCom",
          "tSelectBuilder",
          "tRally",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "lift",
          "cam_CalldownMULE_CommandCenter",
          "cam_Scan_CommandCenter",
          "tStopPlanetaryFortress",
          "move",
          "stop",
          "hold",
          "patrol",
        ],
      },
      {
        id: "refinery",
        cancel: true,
        label: "Refinery",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "supplydepot",
        cancel: true,
        label: "Supply Depot",
        kind: "building",
        card: ["tSelectBuilder", "cam_Lower_SupplyDepot", "tHalt", "cam_Raise_SupplyDepotLowered"],
      },
      {
        id: "barracks",
        cancel: true,
        label: "Barracks",
        kind: "building",
        card: [
          "tMarine",
          "tReaper",
          "tMaraud",
          "tGhost",
          "cam_Medic_Barracks",
          "cam_Firebat_Barracks",
          "tSelectBuilder",
          "tRally",
          "cam_TechReactorAI_Barracks",
          "tTechLabBarracks",
          "aReactor",
          "lift",
          "cam_Spectre_Barracks",
          "move",
          "patrol",
        ],
      },
      {
        id: "engineeringbay",
        cancel: true,
        label: "Engineering Bay",
        kind: "building",
        card: [
          "tTerranInfantryWeaponsLevel1En",
          "tTerranInfantryArmorLevel1Engi",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "bunker",
        cancel: true,
        label: "Bunker",
        kind: "building",
        card: [
          "stop",
          "attack",
          "tSelectBuilder",
          "tRally",
          "tStim",
          "tBunkerLoad",
          "tBunkerUnloadAll",
          "tSalvageBunker",
        ],
      },
      {
        id: "perditionturret",
        cluster: "tower",
        cancel: true,
        label: "Perdition Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "tHalt"],
      },
      {
        id: "missileturret",
        cluster: "tower",
        cancel: true,
        label: "Missile Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "tHalt"],
      },
      {
        id: "sensortower",
        cancel: true,
        label: "Sensor Tower",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "hivemindemulator",
        cancel: true,
        label: "Hive Mind Emulator",
        kind: "building",
        card: ["cam_MindControl_HiveMindEmulator"],
      },
      {
        id: "ghostacademy",
        cancel: true,
        label: "Ghost Academy",
        kind: "building",
        card: [
          "tNukeArmGhostAcademy",
          "tSelectBuilder",
          "tHalt",
          "cam_SpectreNukeArm_GhostAcademy",
        ],
      },
      {
        id: "factory",
        cancel: true,
        label: "Factory",
        kind: "building",
        card: [
          "tHellionFactory",
          "tSiegeTankFactory",
          "tThorFactory",
          "cam_Predator_Factory",
          "cam_Vulture_Factory",
          "cam_Diamondback_Factory",
          "cam_Goliath_Factory",
          "tSelectBuilder",
          "tRally",
          "cam_TechReactorAI_Factory",
          "tTechLabFactory",
          "tReactorFactory",
          "lift",
          "move",
        ],
      },
      {
        id: "armory",
        cancel: true,
        label: "Armory",
        kind: "building",
        card: [
          "tTerranVehicleWeaponsLevel1Arm",
          "cam_TerranVehiclePlatingLevel1_Armory",
          "tTerranShipWeaponsLevel1Armory",
          "cam_TerranShipPlatingLevel1_Armory",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "starport",
        cancel: true,
        label: "Starport",
        kind: "building",
        card: [
          "tVikingFighterStarport",
          "tMedivacStarport",
          "tRavenStarport",
          "tBansheeStarport",
          "tBattlecruiserStarport",
          "cam_Wraith_Starport",
          "cam_BuildHercules_Starport",
          "tSelectBuilder",
          "tRally",
          "cam_TechReactorAI_Starport",
          "tTechLabStarport",
          "tReactorStarport",
          "lift",
          "move",
        ],
      },
      {
        id: "fusioncore",
        cancel: true,
        label: "Fusion Core",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "merccompound",
        cancel: true,
        label: "Merc Compound",
        kind: "building",
        card: [
          "cam_HireKelmorianMiners_MercCompound",
          "cam_HireDevilDogs_MercCompound",
          "cam_HireHammerSecurities_MercCompound",
          "cam_HireSpartanCompany_MercCompound",
          "cam_HireSiegeBreakers_MercCompound",
          "cam_HireHelsAngels_MercCompound",
          "cam_HireDuskWing_MercCompound",
          "cam_HireDukesRevenge_MercCompound",
          "tSelectBuilder",
          "tRally",
          "tHalt",
        ],
      },
      { id: "laserdrill", label: "Drakken Laser Drill", kind: "building", card: ["attack"] },
    ],
  },
  hots: {
    label: "Heart of the Swarm",
    race: "zerg",
    modes: ["campaign"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "kerrigan",
        cluster: "basic",
        label: "Kerrigan",
        kind: "unit",
        card: [
          "cam_MindBolt_K5Kerrigan",
          "cam_PsionicLift_K5Kerrigan",
          "cam_WildMutation_K5Kerrigan",
          "cam_K5Leviathan_K5Kerrigan",
          "burrow",
          "unburrow",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
        ],
      },
      {
        id: "niadra",
        cluster: "basic",
        label: "Niadra",
        kind: "unit",
        card: [
          "cam_ParasiticInvasion_LarvalQueen",
          "cam_GrowSwarmQueen_LarvalQueen",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "cam_SwarmQueenZergling_SwarmQueen",
          "burrow",
          "cam_SwarmQueenRoach_LargeSwarmQueen",
        ],
      },
      {
        id: "stukov",
        cluster: "basic",
        label: "Stukov",
        kind: "unit",
        card: [
          "cam_DevastatingShot_InfestedStukov",
          "cam_StukovInfestedTerrans_InfestedStukov",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
        ],
      },
      {
        id: "dehaka",
        cluster: "basic",
        label: "Dehaka",
        kind: "unit",
        card: [
          "cam_Drag_Dehaka",
          "cam_DehakaMirrorImage_Dehaka",
          "cam_DehakaHeal_Dehaka",
          "burrow",
          "unburrow",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
        ],
      },
      {
        id: "hyperion",
        cluster: "basic",
        label: "Hyperion",
        kind: "unit",
        card: [
          "cam_SJHyperionFightersRecall_SJHyperion",
          "cam_SJHyperionBlink_SJHyperion",
          "cam_SJHyperionFighters_SJHyperion",
          "cam_SJHyperionYamato_SJHyperion",
          "cam_SJHyperionLightningStorm_SJHyperion",
        ],
      },
      {
        id: "leviathan",
        cluster: "basic",
        label: "Leviathan",
        kind: "unit",
        card: ["cam_HotSBioPlasmidDischarge_HotSLeviathan", "cam_HotSBioStasis_HotSLeviathan"],
      },
      {
        id: "warhound",
        cluster: "basic",
        label: "Warhound",
        kind: "unit",
        card: ["cam_TornadoMissile_WarHound"],
      },
      { id: "lyote", label: "Lyote", kind: "unit", card: ["cam_Consume_Lyote"] },
      {
        id: "giantursadon",
        label: "Giant Ursadon",
        kind: "unit",
        card: ["cam_GiantYetiLeap_GiantYeti", "cam_Consume_GiantYeti"],
      },
      {
        id: "larva",
        cancel: true,
        label: "Larva",
        kind: "unit",
        card: [
          "zDrone",
          "zOver",
          "zZerglingLarva",
          "cam_Aberration_Larva",
          "zRoach",
          "zHydra",
          "zInfest",
          "zUltraliskLarva",
          "zSwarmHostMPLarva",
          "zMuta",
          "tRally",
        ],
      },
      {
        id: "drone",
        cluster: "basic",
        cancel: true,
        label: "Drone",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "cam_ZergBuild_Drone_dronebuild0",
          "cam_ZergBuildAdvanced_Drone_dronebuild1",
          "burrow",
        ],
      },
      {
        id: "drone_build0",
        cancel: true,
        label: "Basic Mutation",
        kind: "building",
        parent: "drone",
        card: [
          "zbHatch",
          "zbExtract",
          "cam_SpawningPool_Drone",
          "zbEvo",
          "zbRoachW",
          "zbBane",
          "zbSpine",
          "zbSpore",
        ],
      },
      {
        id: "drone_build1",
        cancel: true,
        label: "Advanced Mutation",
        kind: "building",
        parent: "drone",
        card: ["zbHydra", "zbInfPit", "zbSpire", "zbUltra"],
      },
      {
        id: "queen",
        cluster: "basic",
        label: "Swarm Queen",
        kind: "unit",
        card: ["qCreep", "cam_QueenBurstHeal_Queen", "burrow", "unburrow"],
      },
      {
        id: "zergling",
        label: "Zergling",
        kind: "unit",
        card: ["zBanelingZergling", "burrow", "unburrow"],
      },
      {
        id: "baneling",
        label: "Baneling",
        kind: "unit",
        card: [
          "zExplodeBaneling",
          "zEnableBuildingAttackBaneling",
          "zDisableBuildingAttackBaneling",
          "burrow",
          "unburrow",
        ],
      },
      {
        id: "banelingsplitter",
        label: "Baneling (Splitter)",
        kind: "unit",
        card: [
          "cam_Explode_HotSSplitterlingBig",
          "cam_EnableBuildingAttack_HotSSplitterlingBig",
          "cam_DisableBuildingAttack_HotSSplitterlingBig",
          "burrow",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "cam_DisableBuildingAttack_HotSSplitterlingMedium",
          "unburrow",
        ],
      },
      { id: "aberration", label: "Aberration", kind: "unit", card: ["burrow", "unburrow"] },
      {
        id: "roach",
        cluster: "basic",
        label: "Roach",
        kind: "unit",
        card: ["burrow", "move", "stop", "hold", "patrol", "attack", "unburrow"],
      },
      {
        id: "hydralisk",
        cluster: "basic",
        label: "Hydralisk",
        kind: "unit",
        card: ["zHydraliskFrenzy", "burrow", "unburrow"],
      },
      {
        id: "hydraliskimpaler",
        cluster: "basic",
        label: "Hydralisk (Impaler)",
        kind: "unit",
        card: [
          "cam_Impaler_HydraliskImpaler",
          "cam_HydraliskFrenzy_HydraliskImpaler",
          "burrow",
          "unburrow",
        ],
      },
      {
        id: "hydralisklurker",
        cluster: "basic",
        label: "Hydralisk (Lurker)",
        kind: "unit",
        card: [
          "cam_Lurker_HydraliskLurker",
          "cam_HydraliskFrenzy_HydraliskLurker",
          "burrow",
          "unburrow",
        ],
      },
      {
        id: "impaler",
        cluster: "basic",
        label: "Impaler",
        kind: "unit",
        card: ["cam_ImpalerBurrowDown", "stop", "attack", "cam_ImpalerBurrowUp"],
      },
      {
        id: "lurker",
        cluster: "flying",
        label: "Lurker",
        kind: "unit",
        card: ["zBurrowLurkerMP", "stop", "attack", "cam_LurkerBurrowUp"],
      },
      {
        id: "infestor",
        cluster: "flying",
        cancel: true,
        label: "Infestor",
        kind: "unit",
        card: [
          "zFungalGrowthInfestor",
          "cam_NPSwarm_Infestor",
          "cam_InfestorConsumption_Infestor",
          "burrow",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "unburrow",
        ],
      },
      {
        id: "swarmhost",
        cluster: "basic",
        label: "Swarm Host",
        kind: "unit",
        card: [
          "cam_SwarmHostRoot",
          "stop",
          "attack",
          "cam_LocustLaunch_SwarmHostRooted",
          "cam_SwarmHostUproot",
          "move",
          "hold",
          "patrol",
        ],
      },
      {
        id: "swarmhostcarrion",
        cluster: "basic",
        label: "Swarm Host (Carrion)",
        kind: "unit",
        card: [
          "cam_SwarmHostRoot_2",
          "stop",
          "attack",
          "cam_LocustFlyingLaunch_SwarmHostSplitARooted",
          "cam_SwarmHostUproot_2",
          "move",
          "hold",
          "patrol",
        ],
      },
      {
        id: "swarmhostcreeper",
        cluster: "basic",
        label: "Swarm Host (Creeper)",
        kind: "unit",
        card: [
          "cam_SwarmHostDeepBurrow_SwarmHostSplitB",
          "cam_SwarmHostRoot_3",
          "stop",
          "attack",
          "cam_LocustLaunchCreeper_SwarmHostSplitBRooted",
          "cam_SwarmHostUproot_3",
          "move",
          "hold",
          "patrol",
        ],
      },
      {
        id: "mutaliskbroodlord",
        cluster: "basic",
        label: "Mutalisk (Brood Lord)",
        kind: "unit",
        card: ["cam_BroodLord_MutaliskBroodlord"],
      },
      {
        id: "mutaliskviper",
        cluster: "basic",
        label: "Mutalisk (Viper)",
        kind: "unit",
        card: ["cam_Viper_MutaliskViper"],
      },
      {
        id: "broodlord",
        cluster: "basic",
        label: "Brood Lord",
        kind: "unit",
        card: ["move", "stop", "hold", "patrol", "attack"],
      },
      {
        id: "viper",
        cluster: "flying",
        label: "Viper",
        kind: "unit",
        card: ["zFaceEmbraceViper", "cam_DisablingCloud_Viper", "cam_ViperConsumption_Viper"],
      },
      {
        id: "ultralisk",
        label: "Ultralisk",
        kind: "unit",
        card: ["cam_BurrowChargeCampaign_Ultralisk", "burrow", "unburrow"],
      },
      {
        id: "ultralisknoxious",
        label: "Ultralisk (Noxious)",
        kind: "unit",
        card: [
          "cam_PoisonNova_HotSNoxious",
          "cam_BurrowChargeCampaignNoxious_HotSNoxious",
          "burrow",
          "unburrow",
        ],
      },
      {
        id: "hatchery",
        cancel: true,
        label: "Hatchery",
        kind: "building",
        card: [
          "zLarva",
          "zQueen",
          "cam_RespawnZergling_Hatchery",
          "zRallyEgg",
          "tRally",
          "zLairHatchery",
        ],
      },
      {
        id: "evolutionchamber",
        cancel: true,
        label: "Evolution Chamber",
        kind: "building",
        card: [
          "zZergmeleeweapons1EvolutionCha",
          "zZergmissileweapons1EvolutionC",
          "zZerggroundarmor1EvolutionCham",
        ],
      },
      {
        id: "spinecrawler",
        cluster: "tower",
        cancel: true,
        label: "Spine Crawler",
        kind: "building",
        card: [
          "stop",
          "attack",
          "zSpineCrawlerUproot",
          "move",
          "hold",
          "patrol",
          "zSpineCrawlerRootSpineCrawlerU",
        ],
      },
      {
        id: "sporecrawler",
        cluster: "tower",
        cancel: true,
        label: "Spore Crawler",
        kind: "building",
        card: [
          "stop",
          "attack",
          "zSporeCrawlerUproot",
          "move",
          "hold",
          "patrol",
          "zSporeCrawlerRootSporeCrawlerU",
        ],
      },
      {
        id: "hydraliskden",
        cancel: true,
        label: "Hydralisk Den",
        kind: "building",
        card: ["cam_LurkerDen_HydraliskDen"],
      },
      {
        id: "spire",
        cancel: true,
        label: "Spire",
        kind: "building",
        card: ["zZergflyerattack1", "zZergflyerarmor1", "cam_GreaterSpireBroodlord_Spire"],
      },
      {
        id: "barracks",
        cancel: true,
        label: "Barracks",
        kind: "building",
        card: [
          "tMarine",
          "tReaper",
          "tMaraud",
          "cam_Medic_Barracks_2",
          "cam_Firebat_Barracks_2",
          "tGhost",
          "cam_Spectre_Barracks_2",
          "tSelectBuilder",
          "tRally",
          "cam_TechReactorAI_Barracks_2",
          "tTechLabBarracks",
          "aReactor",
          "lift",
          "cam_HireDevilDogs_Barracks",
          "cam_MercMedic_Barracks",
        ],
      },
      {
        id: "factory",
        cancel: true,
        label: "Factory",
        kind: "building",
        card: [
          "tHellionFactory",
          "tSiegeTankFactory",
          "cam_WarHound_Factory",
          "cam_CampaignVehicles_Factory",
          "tSelectBuilder",
          "tRally",
          "cam_TechReactorAI_Factory_2",
          "tTechLabFactory",
          "tReactorFactory",
          "lift",
          "cam_Vulture_Factory_2",
          "cam_Predator_Factory_2",
          "cam_Diamondback_Factory_2",
          "tThorFactory",
        ],
      },
      {
        id: "starport",
        cancel: true,
        label: "Starport",
        kind: "building",
        card: [
          "tVikingFighterStarport",
          "tMedivacStarport",
          "tRavenStarport",
          "tBansheeStarport",
          "tBattlecruiserStarport",
          "cam_CampaignVehicles_Starport",
          "tSelectBuilder",
          "tRally",
          "cam_TechReactorAI_Starport_2",
          "tTechLabStarport",
          "tReactorStarport",
          "lift",
          "cam_BuildHercules_Starport_2",
          "cam_HireDuskWing_Starport",
        ],
      },
    ],
  },
  lotv: {
    label: "Legacy of the Void",
    race: "protoss",
    modes: ["campaign"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "zeratul",
        cluster: "basic",
        label: "Zeratul",
        kind: "unit",
        card: [
          "cam_ZeratulBlink_PrologueZeratul",
          "cam_PrologueVoidArmor_PrologueZeratul",
          "cam_ShadowBlade_PrologueZeratul",
        ],
      },
      {
        id: "artanis",
        cluster: "basic",
        label: "Artanis",
        kind: "unit",
        card: ["cam_ArtanisLightningDash_ArtanisVoid", "cam_ArtanisAstralWind_ArtanisVoid"],
      },
      {
        id: "vorazun",
        label: "Vorazun",
        kind: "unit",
        card: ["cam_VorazunBlink_VorazunChampion", "cam_MohandarOmnislash_VorazunChampion"],
      },
      {
        id: "alarak",
        label: "Alarak",
        kind: "unit",
        card: ["cam_AlarakKnockback_AlarakChampion", "cam_AlarakDeadlyCharge_AlarakChampion"],
      },
      {
        id: "karax",
        label: "Karax",
        kind: "unit",
        card: ["cam_Reclamation_KaraxChampion", "cam_PhaseCannon_KaraxChampion"],
      },
      {
        id: "fenix",
        cluster: "basic",
        label: "Fenix",
        kind: "unit",
        card: [
          "cam_FenixSOACharge_FenixChampion",
          "cam_FenixWhirlwind_FenixChampion",
          "cam_VoidShieldCapacitor_FenixChampion",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
        ],
      },
      {
        id: "kerrigan",
        cluster: "basic",
        label: "Kerrigan",
        kind: "unit",
        card: [
          "cam_KerriganVoidKineticBlast_KerriganVoidUlnar02",
          "cam_KerriganVoidSpawnBanelings_KerriganVoidUlnar02",
          "stop",
          "attack",
          "move",
          "hold",
          "patrol",
          "cam_KerriganEpilogue03Heal_KerriganEpilogue03",
          "cam_KerriganEpilogue03Extinction_KerriganEpilogue03",
        ],
      },
      {
        id: "probe",
        cluster: "basic",
        cancel: true,
        label: "Probe",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "cam_ProtossBuild_Probe_probebuild0",
          "cam_ProtossBuildAdvanced_Probe_probebuild1",
        ],
      },
      {
        id: "probe_build0",
        cancel: true,
        label: "Warp In Structure",
        kind: "building",
        parent: "probe",
        card: [
          "pNexus",
          "pAssim",
          "pPylon",
          "pGate",
          "pForge",
          "pBattery",
          "pCyber",
          "pCannon",
          "cam_KhaydarinMonolith_Probe",
        ],
      },
      {
        id: "probe_build1",
        cancel: true,
        label: "Warp In Advanced Structure",
        kind: "building",
        parent: "probe",
        card: ["pStargate", "pRobo", "pArchives", "pFleet", "pRoboBay", "pDark"],
      },
      {
        id: "zealot",
        cluster: "basic",
        label: "Zealot",
        kind: "unit",
        card: [
          "cam_Charge_ZealotAiur",
          "cam_VoidZealotWhirlwind_ZealotAiur",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
        ],
      },
      {
        id: "centurion",
        label: "Centurion",
        kind: "unit",
        card: [
          "cam_VoidZealotShadowCharge_ZealotShakuras",
          "cam_VoidZealotShadowChargeStun_ZealotShakuras",
        ],
      },
      { id: "sentinel", label: "Sentinel", kind: "unit", card: ["cam_Charge_ZealotPurifier"] },
      {
        id: "sentry",
        cluster: "basic",
        cancel: true,
        label: "Sentry",
        kind: "unit",
        card: [
          "cam_VoidSentryShieldRepairDouble_SentryAiur",
          "cam_GuardianShield_SentryAiur",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
          "pForceFieldSentry",
        ],
      },
      {
        id: "energizer",
        label: "Energizer",
        kind: "unit",
        card: [
          "cam_VoidSentryChronoBeam_SentryPurifier",
          "cam_VoidSentryPhasingMode_SentryPurifier",
          "cam_VoidSentryMobileMode_SentryPurifier",
        ],
      },
      {
        id: "havoc",
        label: "Havoc",
        kind: "unit",
        card: ["cam_TargetLock_Monitor", "cam_SentryTaldarimForceField_Monitor"],
      },
      {
        id: "stalker",
        cluster: "basic",
        label: "Stalker",
        kind: "unit",
        card: [
          "cam_StalkerBlinkShieldRestoreBase_StalkerShakuras",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
        ],
      },
      {
        id: "adept",
        cluster: "basic",
        cancel: true,
        label: "Adept",
        kind: "unit",
        card: ["pAdeptPhaseShift", "move", "stop", "hold", "patrol", "attack"],
      },
      {
        id: "hightemplar",
        cluster: "basic",
        label: "High Templar",
        kind: "unit",
        card: [
          "pFeedbackHighTemplar",
          "pPsiStormHighTemplar",
          "pAWrp",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
        ],
      },
      {
        id: "darkarchon",
        cluster: "basic",
        label: "Dark Archon",
        kind: "unit",
        card: ["cam_DarkArchonConfusion_DarkArchon", "cam_DarkArchonMindControl_DarkArchon"],
      },
      {
        id: "ascendant",
        label: "Ascendant",
        kind: "unit",
        card: [
          "cam_VoidHighTemplarPsiOrb_HighTemplarTaldarim",
          "cam_VoidHighTemplarMindBlast_HighTemplarTaldarim",
          "cam_AscendantSacrifice_HighTemplarTaldarim",
        ],
      },
      {
        id: "darktemplar",
        cluster: "basic",
        label: "Dark Templar",
        kind: "unit",
        card: [
          "cam_VoidDarkTemplarShadowFury_DarkTemplarShakuras",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
        ],
      },
      {
        id: "bloodhunter",
        label: "Blood Hunter",
        kind: "unit",
        card: ["cam_VoidStasis_DarkTemplarTaldarim"],
      },
      {
        id: "immortal",
        cluster: "basic",
        label: "Immortal",
        kind: "unit",
        card: ["cam_ImmortalOverload_Immortal"],
      },
      {
        id: "annihilator",
        label: "Annihilator",
        kind: "unit",
        card: ["cam_ImmortalShakurasShadowCannon_ImmortalShakuras"],
      },
      {
        id: "reaver",
        cluster: "basic",
        label: "Reaver",
        kind: "unit",
        card: ["cam_ReaverScarabs_Reaver"],
      },
      {
        id: "phoenix",
        cluster: "basic",
        cancel: true,
        label: "Phoenix",
        kind: "unit",
        card: ["pGravitonBeamPhoenix"],
      },
      {
        id: "corsair",
        cluster: "basic",
        label: "Corsair",
        kind: "unit",
        card: ["cam_CorsairMPDisruptionWeb_CorsairMP"],
      },
      {
        id: "mirage",
        cancel: true,
        label: "Mirage",
        kind: "unit",
        card: ["cam_GravitonBeam_PhoenixPurifier"],
      },
      {
        id: "arbiter",
        cluster: "basic",
        label: "Arbiter",
        kind: "unit",
        card: ["cam_ArbiterMPStasisField_ArbiterMP", "cam_ArbiterMPRecall_ArbiterMP"],
      },
      {
        id: "carrier",
        cluster: "basic",
        cancel: true,
        label: "Carrier",
        kind: "unit",
        card: [
          "pInterceptorCarrier",
          "cam_RepairDrones_Carrier",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
        ],
      },
      {
        id: "tempest",
        cluster: "basic",
        cancel: true,
        label: "Tempest",
        kind: "unit",
        card: ["cam_LightningBomb_Tempest", "move", "stop", "hold", "patrol", "attack"],
      },
      {
        id: "mothership",
        cluster: "basic",
        label: "Mothership",
        kind: "unit",
        card: [
          "cam_VoidSentryBlackHole_SOAMothershipv4",
          "cam_SOAMothershipLineAttack_SOAMothershipv4",
          "cam_SOAMothershipBlink_SOAMothershipv4",
        ],
      },
      {
        id: "queen",
        cluster: "basic",
        label: "Queen",
        kind: "unit",
        card: [
          "cam_QueenClassicParasite_QueenClassic",
          "cam_QueenMPEnsnare_QueenClassic",
          "cam_QueenMPSpawnBroodlings_QueenClassic",
          "cam_CreepTumor_QueenClassic",
        ],
      },
      { id: "taurenmarine", label: "Tauren Space Marine", kind: "unit", card: ["tStim"] },
      {
        id: "nexus",
        cancel: true,
        label: "Nexus",
        kind: "building",
        card: ["pProbe", "stop", "attack", "tRally", "cam_TimeWarp_Nexus"],
      },
      {
        id: "gateway",
        cancel: true,
        label: "Gateway",
        kind: "building",
        card: [
          "pZealot",
          "pSentry",
          "pStalker",
          "pHT",
          "pDT",
          "tRally",
          "pUpgradeToWarpGateGateway",
        ],
      },
      {
        id: "shieldbattery",
        cancel: true,
        label: "Shield Battery",
        kind: "building",
        card: ["stop", "pShieldBatteryRecharge"],
      },
      {
        id: "forge",
        cancel: true,
        label: "Forge",
        kind: "building",
        card: [
          "pProtossGroundWeaponsLevel1For",
          "pProtossGroundArmorLevel1Forge",
          "pProtossShieldsLevel1Forge",
        ],
      },
      {
        id: "photoncannon",
        cluster: "tower",
        cancel: true,
        label: "Photon Cannon",
        kind: "building",
        card: ["stop", "attack"],
      },
      {
        id: "monolith",
        cancel: true,
        label: "Khaydarin Monolith",
        kind: "building",
        card: ["stop", "attack"],
      },
      {
        id: "cyberneticscore",
        cancel: true,
        label: "Cybernetics Core",
        kind: "building",
        card: ["pProtossAirWeaponsLevel1Cybern", "pProtossAirArmorLevel1Cybernet"],
      },
      { id: "darkshrine", cancel: true, label: "Dark Shrine", kind: "building", card: ["tRally"] },
      {
        id: "roboticsfacility",
        cancel: true,
        label: "Robotics Facility",
        kind: "building",
        card: [
          "pImmortalRoboticsFacility",
          "pColossusRoboticsFacility",
          "tRally",
          "cam_UpgradeToRoboticsFacilityWarp_RoboticsFacility",
          "cam_MorphBackToRoboticsFacility_RoboticsFacilityWarp",
        ],
      },
      {
        id: "stargate",
        cancel: true,
        label: "Stargate",
        kind: "building",
        card: [
          "pPhoenixStargate",
          "pVoidRayStargate",
          "pCarrierStargate",
          "tRally",
          "cam_UpgradeToStargateWarp_Stargate",
          "cam_MorphBackToStargate_StargateWarp",
        ],
      },
    ],
  },
  nco: {
    label: "Nova Covert Ops",
    race: "terran",
    modes: ["campaign"],
    contexts: [
      { id: "none", label: "— nothing —", card: [] },
      {
        id: "nova",
        cluster: "basic",
        cancel: true,
        label: "Nova",
        kind: "unit",
        card: [
          "cam_GhostHoldFire_NovaHero",
          "cam_WeaponsFree_NovaHero",
          "cam_NovaWeaponCanisterRifleSnipe_NovaHero",
          "cam_NovaGadgetPulseGrenades_NovaHero",
          "cam_ApolloCloakOnNova_NovaHero",
          "cam_NovaDomination_NovaHero",
          "cam_HeroNukeCalldown_NovaHero",
        ],
      },
      {
        id: "scv",
        cluster: "basic",
        cancel: true,
        label: "SCV",
        kind: "unit",
        card: [
          "gatherProt",
          "returnCargo",
          "cam_TerranBuild_SCV_scvbuild0_2",
          "cam_TerranBuildAdvanced_SCV_scvbuild1_2",
          "repair",
          "tHalt",
        ],
      },
      {
        id: "scv_build0",
        cancel: true,
        label: "Build Structure",
        kind: "building",
        parent: "scv",
        card: ["bCmdCtr", "bRef", "cam_SupplyDepot_SCV_2", "bRax", "bEbay", "bBunker", "bMissile"],
      },
      {
        id: "scv_build1",
        cancel: true,
        label: "Build Advanced Structure",
        kind: "building",
        parent: "scv",
        card: ["bGhostAcad", "bFactory", "bArmory", "bStarport", "bFusion"],
      },
      {
        id: "marine",
        cluster: "basic",
        label: "Marine",
        kind: "unit",
        card: ["tStim", "cam_MagrailMunitions_Marine"],
      },
      {
        id: "marauder",
        cluster: "basic",
        label: "Marauder",
        kind: "unit",
        card: ["tStim", "cam_MagrailMunitions_Marauder"],
      },
      { id: "reaper", cluster: "basic", label: "Reaper", kind: "unit", card: ["tStim"] },
      {
        id: "hellbat",
        cluster: "basic",
        label: "Hellbat",
        kind: "unit",
        card: ["tStim", "tMorphToHellion"],
      },
      {
        id: "siegetank",
        cluster: "basic",
        label: "Siege Tank",
        kind: "unit",
        card: ["tSiegeMode", "tUnsiege", "cam_DeploySpiderMines_SiegeTank"],
      },
      {
        id: "liberator",
        cluster: "basic",
        label: "Liberator",
        kind: "unit",
        card: ["tLiberatorAGMode", "tLiberatorAAMode", "tCloakOff"],
      },
      {
        id: "raven",
        cluster: "flying",
        label: "Raven",
        kind: "unit",
        card: [
          "tAutoTurretRaven",
          "cam_HunterSeekerMissile_Raven_2",
          "move",
          "stop",
          "hold",
          "patrol",
          "attack",
        ],
      },
      {
        id: "banshee",
        cluster: "basic",
        label: "Banshee",
        kind: "unit",
        card: ["tCloakOnBanshee", "tCloakOff"],
      },
      {
        id: "battlecruiser",
        cluster: "basic",
        label: "Battlecruiser",
        kind: "unit",
        card: ["tYamatoGun", "tHyperjumpBattlecruiser", "tCloakOff"],
      },
      { id: "trooper", label: "Trooper", kind: "unit", card: ["tStim"] },
      { id: "herc", cluster: "basic", label: "HERC", kind: "unit", card: ["cam_HercGrapple_HERC"] },
      {
        id: "ghost",
        cluster: "basic",
        cancel: true,
        label: "Ghost",
        kind: "unit",
        card: [
          "nuke",
          "holdfire",
          "tWeaponsFreeGhost",
          "tChannelSnipeGhost",
          "emp",
          "tCloakOnBanshee",
          "tCloakOff",
        ],
      },
      { id: "sonardrone", label: "Sonar Drone", kind: "unit", card: ["cam_EMP_NovaSonarDrone"] },
      {
        id: "defiler",
        cluster: "flying",
        label: "Defiler",
        kind: "unit",
        card: ["cam_InfestorConsumption_DefilerMP", "burrow", "unburrow"],
      },
      {
        id: "commandcenter",
        cancel: true,
        label: "Command Center",
        kind: "building",
        card: [
          "tScv",
          "mOrbital",
          "tSelectBuilder",
          "tRally",
          "tCommandCenterLoad",
          "tCommandCenterUnloadAll",
          "lift",
          "tScanOrbitalCommand",
          "move",
          "stop",
          "hold",
          "patrol",
        ],
      },
      {
        id: "supplydepot",
        cancel: true,
        label: "Supply Depot",
        kind: "building",
        card: [
          "tSelectBuilder",
          "cam_Lower_SupplyDepot_2",
          "tHalt",
          "cam_Raise_SupplyDepotLowered_2",
        ],
      },
      {
        id: "refinery",
        cancel: true,
        label: "Refinery",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "barracks",
        cancel: true,
        label: "Barracks",
        kind: "building",
        card: [
          "tMarine",
          "tReaper",
          "tMaraud",
          "tSelectBuilder",
          "tTechLabBarracks",
          "aReactor",
          "lift",
          "move",
          "stop",
          "hold",
          "patrol",
        ],
      },
      {
        id: "engineeringbay",
        cancel: true,
        label: "Engineering Bay",
        kind: "building",
        card: [
          "tTerranInfantryWeaponsLevel1En",
          "tTerranInfantryArmorLevel1Engi",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "bunker",
        cancel: true,
        label: "Bunker",
        kind: "building",
        card: [
          "stop",
          "attack",
          "tSelectBuilder",
          "tRally",
          "tStim",
          "tBunkerLoad",
          "tBunkerUnloadAll",
          "tSalvageBunker",
        ],
      },
      {
        id: "missileturret",
        cluster: "tower",
        cancel: true,
        label: "Missile Turret",
        kind: "building",
        card: ["stop", "attack", "tSelectBuilder", "cam_Salvage_MissileTurret", "tHalt"],
      },
      {
        id: "ghostacademy",
        cancel: true,
        label: "Ghost Academy",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "factory",
        cancel: true,
        label: "Factory",
        kind: "building",
        card: [
          "tHellionTankFactory",
          "tSiegeTankFactory",
          "cam_Goliath_Factory_2",
          "tSelectBuilder",
          "tTechLabFactory",
          "tReactorFactory",
          "lift",
          "move",
          "stop",
          "hold",
        ],
      },
      {
        id: "armory",
        cancel: true,
        label: "Armory",
        kind: "building",
        card: [
          "cam_TerranVehicleAndShipWeaponsLevel1_Armory",
          "tTerranVehicleAndShipPlatingLe",
          "tSelectBuilder",
          "tHalt",
        ],
      },
      {
        id: "starport",
        cancel: true,
        label: "Starport",
        kind: "building",
        card: [
          "tLiberatorStarport",
          "tBansheeStarport",
          "tRavenStarport",
          "tBattlecruiserStarport",
          "tSelectBuilder",
          "tTechLabStarport",
          "tReactorStarport",
          "lift",
          "move",
          "patrol",
        ],
      },
      {
        id: "fusioncore",
        cancel: true,
        label: "Fusion Core",
        kind: "building",
        card: ["tSelectBuilder", "tHalt"],
      },
      {
        id: "herccompound",
        cancel: true,
        label: "HERC Compound",
        kind: "building",
        card: ["tSelectBuilder", "tRally"],
      },
    ],
  },
};
